import { Button as DevButton } from "devextreme-react/button";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import { bidvApi } from "../../../api/bidvApi";
import { mucPhaiThuApi } from "../../../api/mucPhaiThuApi";
import { showNotify } from "../../../helpers/toast";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { RootState } from "../../../state/reducers";
import Button from "../../../components/ui/button";
import ModalActions from "../../../components/ui/modal/ModalActions";
import Modal from "../../../components/ui/modal";
import { PlaceHolder } from "../../place-holder";
import styles from "./TaoBienLai.module.css";
import { ChecklistIcon, XIcon, CreditCardIcon, CopyIcon, DownloadIcon, FileIcon, KeyIcon } from "@primer/octicons-react";
import { formatVND } from "../../../utils/formatVND";
import { saveAs } from "file-saver-es";

type ThuPhiTaoBienLaiBtnProps = {
  disabled: boolean;
  sf_mucphaithu: sf_mucphaithu;
  usePopupButton?: boolean;
  printType?: "bienlai" | "thongbaophi";
  buttonText?: string;
  ts_hocsinh?: any;
};

const ThuPhiTaoBienLaiBtn = (props: ThuPhiTaoBienLaiBtnProps) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const isThongBaoPhi = props.printType === "thongbaophi";
  const printButtonText = props.buttonText || (isThongBaoPhi ? "In thông báo phí" : "In biên lai");

  const handleOpenModal = useCallback(() => {
    setIsShowModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsShowModal(false);
  }, []);

  return (
    <>
      {props.usePopupButton ? (
        <Button
          variant="default"
          text={printButtonText}
          iconClass="fa fa-print"
          disabled={props.disabled}
          onClick={handleOpenModal}
        />
      ) : (
        <DevButton
          text={printButtonText}
          type="default"
          stylingMode="text"
          icon="print"
          className="p-btn-devextreme"
          disabled={props.disabled}
          onClick={handleOpenModal}
        />
      )}
      <Modal
        title={printButtonText}
        width="95%"
        isOpen={isShowModal}
        onClose={handleCloseModal}
      >
        <PrintModal
          sf_mucphaithu={props.sf_mucphaithu}
          printType={props.printType}
          onClose={handleCloseModal}
          ts_hocsinh={props.ts_hocsinh}
        />
      </Modal>
    </>
  );
};

type PrintModalProps = {
  sf_mucphaithu: sf_mucphaithu;
  printType?: "bienlai" | "thongbaophi";
  title?: string;
  onClose: () => void;
  ts_hocsinh?: any;
};

export const QRModalContent = (props: {
  sf_mucphaithu: sf_mucphaithu;
  ts_hocsinh?: any;
  onClose: () => void;
}) => {
  const [qrImageUrl, setQrImageUrl] = useState<string>("");
  const [qrLoading, setQrLoading] = useState<boolean>(true);

  const maHs = props.ts_hocsinh?.ma_hs || (props.sf_mucphaithu as any).ma_hs || "";
  const hoTen = props.ts_hocsinh?.ho_ten || (props.sf_mucphaithu as any).ho_ten || "";
  const qrPrefix = "BIDV-QR TP";
  const studentInfo = [maHs, hoTen].filter(Boolean).join(" ");
  const baseContent = props.sf_mucphaithu.noi_dung || `Thanh toan CT ${props.sf_mucphaithu.so_chung_tu}`;
  const rawContent = studentInfo ? `${studentInfo} ${baseContent}` : baseContent;
  let fullContent = rawContent;
  if (!fullContent.startsWith("BIDV-QR")) {
    fullContent = `${qrPrefix} ${fullContent}`;
  } else if (fullContent.startsWith("BIDV-QR ") && !fullContent.startsWith("BIDV-QR TP")) {
    fullContent = fullContent.replace("BIDV-QR ", `${qrPrefix} `);
  }

  useEffect(() => {
    const bankBINId = "BIDV";
    const accountNo = "2892899998";
    const accountName = "TRƯỜNG TIỂU HỌC VÀ TRUNG HỌC CƠ SỞ XANH TUỆ ĐỨC";
    const amount = Math.max(0, Math.floor(props.sf_mucphaithu.tong_tien_phai_nop - props.sf_mucphaithu.tong_tien_da_nop));

    const vietQrUrl = `https://img.vietqr.io/image/${bankBINId}-${accountNo}-compact2.png?amount=${amount}&addInfo=${encodeURIComponent(fullContent)}&accountName=${encodeURIComponent(accountName)}`;

    setQrImageUrl(vietQrUrl);
    setQrLoading(false);
  }, [props.sf_mucphaithu, props.ts_hocsinh, fullContent]);

  const handleCopyText = (text: string, label: string) => {
    navigator.clipboard.writeText(text);
    showNotify({ message: `Đã sao chép ${label}`, type: "success" });
  };

  const handleDownloadQr = () => {
    if (!qrImageUrl) return;
    const link = document.createElement("a");
    link.href = qrImageUrl;
    link.download = `VietQR_${props.sf_mucphaithu.so_chung_tu}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className={styles.qrContainer}>
      <div className={styles.qrTitle}>Mã QR Thanh toán</div>
      <div className={styles.qrSubtitle}>Sử dụng ứng dụng ngân hàng quét mã VietQR để thanh toán nhanh</div>

      {qrLoading ? (
        <div style={{ padding: "40px 0", textAlign: "center", width: "100%" }}>
          <PlaceHolder line_number={5} />
          <div style={{ marginTop: "12px", color: "#586069" }}>Đang khởi tạo mã QR thanh toán...</div>
        </div>
      ) : (
        <>
          <div className={styles.qrImageSection}>
            {qrImageUrl ? (
              <img src={qrImageUrl} alt="VietQR" className={styles.qrImage} />
            ) : (
              <div style={{ color: "#d73a49", padding: "20px 0" }}>Không thể tạo mã QR. Vui lòng thử lại.</div>
            )}
            {qrImageUrl && (
              <button className={styles.downloadButton} onClick={handleDownloadQr}>
                <DownloadIcon /> Tải ảnh QR
              </button>
            )}
          </div>

          <div className={styles.qrDetailsSection}>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Học sinh</span>
              <div className={styles.detailValueContainer}>
                <span className={styles.detailValue}>
                  {hoTen || ""} ({maHs || ""})
                </span>
              </div>
            </div>

            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Số tài khoản</span>
              <div className={styles.detailValueContainer}>
                <span className={styles.detailValue} style={{ fontWeight: "bold" }}>
                  2892899998
                </span>
                <button
                  className={styles.copyButton}
                  onClick={() => handleCopyText("2892899998", "số tài khoản")}
                >
                  <CopyIcon size={14} /> Sao chép
                </button>
              </div>
            </div>

            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Ngân hàng</span>
              <div className={styles.detailValueContainer}>
                <span className={styles.detailValue} style={{ fontSize: "13px", fontWeight: "600" }}>
                  Ngân hàng BIDV – Ngọc Khánh
                </span>
                <button
                  className={styles.copyButton}
                  onClick={() => handleCopyText("Ngân hàng BIDV - Ngọc Khánh", "ngân hàng")}
                >
                  <CopyIcon size={14} /> Sao chép
                </button>
              </div>
            </div>

            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Mã số thuế</span>
              <div className={styles.detailValueContainer}>
                <span className={styles.detailValue} style={{ fontWeight: "bold" }}>
                  0108388998
                </span>
                <button
                  className={styles.copyButton}
                  onClick={() => handleCopyText("0108388998", "mã số thuế")}
                >
                  <CopyIcon size={14} /> Sao chép
                </button>
              </div>
            </div>

            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Tên tài khoản</span>
              <div className={styles.detailValueContainer}>
                <span className={styles.detailValue} style={{ fontSize: "13px", fontWeight: "600" }}>
                  TRƯỜNG TIỂU HỌC VÀ TRUNG HỌC CƠ SỞ XANH TUỆ ĐỨC
                </span>
                <button
                  className={styles.copyButton}
                  onClick={() => handleCopyText("TRƯỜNG TIỂU HỌC VÀ TRUNG HỌC CƠ SỞ XANH TUỆ ĐỨC", "tên tài khoản")}
                >
                  <CopyIcon size={14} /> Sao chép
                </button>
              </div>
            </div>

            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Số tiền cần nộp</span>
              <div className={styles.detailValueContainer}>
                <span className={styles.detailValue} style={{ fontWeight: "bold", color: "#cf222e" }}>
                  {formatVND(props.sf_mucphaithu.tong_tien_phai_nop - props.sf_mucphaithu.tong_tien_da_nop)} đ
                </span>
                <button
                  className={styles.copyButton}
                  onClick={() => handleCopyText(
                    Math.max(0, Math.floor(props.sf_mucphaithu.tong_tien_phai_nop - props.sf_mucphaithu.tong_tien_da_nop)).toString(),
                    "số tiền"
                  )}
                >
                  <CopyIcon size={14} /> Sao chép
                </button>
              </div>
            </div>

            <div className={styles.detailRow} style={{ borderBottom: "none" }}>
              <span className={styles.detailLabel}>Nội dung chuyển khoản</span>
              <div className={styles.detailValueContainer}>
                <span className={styles.detailValue}>
                  {fullContent}
                </span>
                <button
                  className={styles.copyButton}
                  onClick={() => handleCopyText(fullContent, "nội dung")}
                >
                  <CopyIcon size={14} /> Sao chép
                </button>
              </div>
            </div>
          </div>

          <ModalActions>
            <Button
              variant="default"
              leadingVisual={XIcon}
              text="Đóng"
              onClick={props.onClose}
            />
          </ModalActions>
        </>
      )}
    </div>
  );
};

export const ThuPhiQRBtn = (props: {
  disabled?: boolean;
  sf_mucphaithu: sf_mucphaithu;
  ts_hocsinh?: any;
}) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const handleOpenModal = useCallback(() => {
    setIsShowModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsShowModal(false);
  }, []);

  return (
    <>
      <DevButton
        text="Mã QR Thanh toán"
        type="default"
        stylingMode="text"
        icon="money"
        className="p-btn-devextreme"
        disabled={props.disabled}
        onClick={handleOpenModal}
      />
      {isShowModal && (
        <Modal
          title="Mã QR Thanh toán BIDV"
          width="60%"
          isOpen={isShowModal}
          onClose={handleCloseModal}
        >
          <QRModalContent
            sf_mucphaithu={props.sf_mucphaithu}
            ts_hocsinh={props.ts_hocsinh}
            onClose={handleCloseModal}
          />
        </Modal>
      )}
    </>
  );
};

export const PrintModal = (props: PrintModalProps) => {
  const [print_url, set_print_url] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isShowQrModal, setIsShowQrModal] = useState<boolean>(false);
  const [isShowBidvQrModal, setIsShowBidvQrModal] = useState<boolean>(false);
  const [bidvQrLoading, setBidvQrLoading] = useState<boolean>(false);
  const [bidvQrImage, setBidvQrImage] = useState<string>("");
  const [bidvQrData, setBidvQrData] = useState<any>(null);
  const { user_info } = useSelector((x: RootState) => x.auth);
  const isBidvUser = user_info?.username === "0963882798" || (user_info as any)?.user_id === 6343;
  // console.log(">>> user_info:", user_info);

  const handleGenBidvQr = async () => {
    setBidvQrLoading(true);
    setBidvQrImage("");
    setBidvQrData(null);
    try {
      const res: any = await mucPhaiThuApi.gen_qr({ sf_mucphaithu_id: props.sf_mucphaithu.id });
      if (res.is_success && res.data) {
        setBidvQrImage(res.data.qrImage || "");
        setBidvQrData(res.data);
      } else {
        showNotify({ message: res.message || "Không thể tạo mã QR từ BIDV", type: "warning" });
      }
    } catch (error) {
      console.error("BIDV gen_qr error:", error);
      showNotify({ message: "Lỗi kết nối API BIDV", type: "error" });
    } finally {
      setBidvQrLoading(false);
    }
  };

  const handleDownloadBidvQr = () => {
    if (!bidvQrImage) return;
    const link = document.createElement("a");
    link.href = bidvQrImage.startsWith("data:") ? bidvQrImage : `data:image/png;base64,${bidvQrImage}`;
    link.download = `BIDV_QR_${props.sf_mucphaithu.so_chung_tu || "export"}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    handleFetchData();
  }, [props.sf_mucphaithu.id]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "p") {
        e.preventDefault();
        handlePrint();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [print_url]);

  const handleFetchData = async () => {
    setIsLoading(true);
    const isPhaithuGoc =
      props.sf_mucphaithu.so_chung_tu.includes("CT") ||
      props.sf_mucphaithu.so_chung_tu.includes("RV") ||
      props.sf_mucphaithu.so_chung_tu.includes("NO") ||
      !props.sf_mucphaithu.sf_mucphaithu_parent_id ||
      props.sf_mucphaithu.sf_mucphaithu_parent_id === 0;
    const data_send: any = {
      sf_mucphaithu_id: isPhaithuGoc
        ? props.sf_mucphaithu.id
        : props.sf_mucphaithu.sf_mucphaithu_parent_id,
      sf_mucphaithu_root_id: props.sf_mucphaithu.id,
    };
    const res = props.printType === "thongbaophi"
      ? await bienLaiThuApi.print_thongbaophi(data_send)
      : await bienLaiThuApi.print(data_send);
    if (res.is_success) {
      set_print_url(res.data);
    } else {
      set_print_url("");
      showNotify({ message: res.message || "Không tải được dữ liệu in", type: "warning" });
    }
    setIsLoading(false);
  };

  const [isExportingExcel, setIsExportingExcel] = useState<boolean>(false);

  const handleExportExcel = async () => {
    setIsExportingExcel(true);
    try {
      const isPhaithuGoc =
        props.sf_mucphaithu.so_chung_tu.includes("CT") ||
        props.sf_mucphaithu.so_chung_tu.includes("RV") ||
        props.sf_mucphaithu.so_chung_tu.includes("NO") ||
        !props.sf_mucphaithu.sf_mucphaithu_parent_id ||
        props.sf_mucphaithu.sf_mucphaithu_parent_id === 0;

      const data_send: any = {
        sf_mucphaithu_id: isPhaithuGoc
          ? props.sf_mucphaithu.id
          : props.sf_mucphaithu.sf_mucphaithu_parent_id,
        sf_mucphaithu_root_id: props.sf_mucphaithu.id,
      };
      const res = props.printType === "thongbaophi"
        ? await bienLaiThuApi.export_thongbaophi_excel(data_send)
        : await bienLaiThuApi.export_excel(data_send);
      if (res && res.data) {
        const fileName = `${props.printType === "thongbaophi" ? "ThongBaoPhi" : "BienLai"}_${props.sf_mucphaithu.so_chung_tu || "export"}.xlsx`;
        saveAs(res.data, fileName);
        showNotify({ message: "Xuất Excel thành công", type: "success" });
      } else {
        showNotify({ message: "Không tải được file Excel", type: "warning" });
      }
    } catch (error) {
      console.error("Export Excel error:", error);
      showNotify({ message: "Lỗi hệ thống khi xuất file Excel", type: "error" });
    } finally {
      setIsExportingExcel(false);
    }
  };

  const handleExportPdf = () => {
    const iframe = document.getElementById("iframe_print_preview") as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } else {
      window.print();
    }
  };

  const handlePrint = () => {
    const iframe = document.getElementById("iframe_print_preview") as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } else {
      window.print();
    }
  };

  return (
    <div className={styles.custom_width}>
      <div style={{ padding: "0 10px" }}>
        {isLoading && <PlaceHolder line_number={20} />}
        {!isLoading && (
          <div id="embed_print_bienlai_container">
            <iframe
              id="iframe_print_preview"
              srcDoc={`
                  <html>
                    <head>
                      <style>
                        @media print {
                          * {
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                          }
                        }
                      </style>
                    </head>
                    <body>
                      ${print_url}
                      <script>
                        window.addEventListener("keydown", (e) => {
                          if ((e.ctrlKey || e.metaKey) && e.key === "p") {
                            e.preventDefault();
                            window.print();
                          }
                        });
                      </script>
                    </body>
                  </html>
                `}
              width="100%"
              height={window.innerHeight - 210}
              title={props.title || "Xem trước"}
              style={{ border: "1px solid #ddd", borderRadius: "4px" }}
            ></iframe>
          </div>
        )}
        <ModalActions>
          <Button
            variant="default"
            leadingVisual={XIcon}
            text="Đóng"
            onClick={props.onClose}
          />
          <Button
            variant="default"
            leadingVisual={FileIcon}
            text="Xuất Excel"
            onClick={handleExportExcel}
            isLoading={isExportingExcel}
          />
          <Button
            variant="default"
            leadingVisual={DownloadIcon}
            text="Xuất PDF"
            onClick={handleExportPdf}
            disabled={!print_url}
          />
          <Button
            variant="default"
            leadingVisual={CreditCardIcon}
            text="Mã QR Thanh toán"
            onClick={() => setIsShowQrModal(true)}
          />
          {props.printType === "thongbaophi" && (
            <Button
              variant="default"
              leadingVisual={KeyIcon}
              text="Test BIDV"
              onClick={() => { setIsShowBidvQrModal(true); handleGenBidvQr(); }}
            />
          )}
          <Button
            variant="primary"
            leadingVisual={ChecklistIcon}
            text={props.printType === "thongbaophi" ? "In thông báo phí" : "In biên lai"}
            onClick={handlePrint}
            isLoading={isLoading}
            disabled={!print_url}
          />
        </ModalActions>
      </div>

      {isShowQrModal && (
        <Modal
          title="Mã QR Thanh toán BIDV"
          width="60%"
          isOpen={isShowQrModal}
          onClose={() => setIsShowQrModal(false)}
        >
          <QRModalContent
            sf_mucphaithu={props.sf_mucphaithu}
            ts_hocsinh={props.ts_hocsinh}
            onClose={() => setIsShowQrModal(false)}
          />
        </Modal>
      )}

      {isShowBidvQrModal && (
        <Modal
          title="Mã QR BIDV (API đối tác)"
          width="60%"
          isOpen={isShowBidvQrModal}
          onClose={() => setIsShowBidvQrModal(false)}
        >
          <div className={styles.qrContainer}>
            <div className={styles.qrTitle}>Mã QR từ BIDV API</div>
            <div className={styles.qrSubtitle}>Mã QR được tạo trực tiếp từ hệ thống BIDV</div>
            {bidvQrLoading ? (
              <div style={{ padding: "40px 0", textAlign: "center", width: "100%" }}>
                <PlaceHolder line_number={5} />
                <div style={{ marginTop: "12px", color: "#586069" }}>Đang gọi API BIDV tạo mã QR...</div>
              </div>
            ) : bidvQrImage ? (
              <>
                <div className={styles.qrImageSection}>
                  <img
                    src={bidvQrImage.startsWith("data:") ? bidvQrImage : `data:image/png;base64,${bidvQrImage}`}
                    alt="BIDV QR"
                    className={styles.qrImage}
                  />
                  <button className={styles.downloadButton} onClick={handleDownloadBidvQr}>
                    <DownloadIcon /> Tải ảnh QR
                  </button>
                </div>
                {bidvQrData && (
                  <div className={styles.qrDetailsSection}>
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>Mã khách hàng</span>
                      <span className={styles.detailValue}>{bidvQrData.code || ""}</span>
                    </div>
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>Tên</span>
                      <span className={styles.detailValue}>{bidvQrData.name || ""}</span>
                    </div>
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>Số tiền</span>
                      <span className={styles.detailValue} style={{ fontWeight: "bold", color: "#cf222e" }}>
                        {formatVND(Number(bidvQrData.amount) || 0)} đ
                      </span>
                    </div>
                    <div className={styles.detailRow} style={{ borderBottom: "none" }}>
                      <span className={styles.detailLabel}>Nội dung</span>
                      <span className={styles.detailValue}>{bidvQrData.description || ""}</span>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div style={{ color: "#d73a49", padding: "20px 0", textAlign: "center" }}>Không thể tạo mã QR từ BIDV.</div>
            )}
            <ModalActions>
              <Button variant="default" leadingVisual={XIcon} text="Đóng" onClick={() => setIsShowBidvQrModal(false)} />
              <Button variant="default" leadingVisual={KeyIcon} text="Tạo lại QR" onClick={handleGenBidvQr} isLoading={bidvQrLoading} />
            </ModalActions>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ThuPhiTaoBienLaiBtn;

